module.exports = __webpack_public_path__ + "media/images/emoticons/book-4fb8d0ba6761d0df5352485ab8211c18.gif";